import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHamburgerMenu = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect width={16} height={16} fill="white" fillOpacity={0.01} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.59998 3.19995C1.30543 3.19995 1.06665 3.43874 1.06665 3.73328C1.06665 4.02783 1.30543 4.26662 1.59998 4.26662H14.4C14.6945 4.26662 14.9333 4.02783 14.9333 3.73328C14.9333 3.43874 14.6945 3.19995 14.4 3.19995H1.59998ZM1.06665 7.99995C1.06665 7.7054 1.30543 7.46662 1.59998 7.46662H14.4C14.6945 7.46662 14.9333 7.7054 14.9333 7.99995C14.9333 8.2945 14.6945 8.53328 14.4 8.53328H1.59998C1.30543 8.53328 1.06665 8.2945 1.06665 7.99995ZM1.06665 12.2666C1.06665 11.9721 1.30543 11.7333 1.59998 11.7333H14.4C14.6945 11.7333 14.9333 11.9721 14.9333 12.2666C14.9333 12.5611 14.6945 12.8 14.4 12.8H1.59998C1.30543 12.8 1.06665 12.5611 1.06665 12.2666Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHamburgerMenu)
const IconSvgHamburgerMenu = createIcon(ForwardRef, 'SvgHamburgerMenu')
export default IconSvgHamburgerMenu
